import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPaymentWero = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 24"
    ref={ref}
    {...props}
  >
    <defs>
      <linearGradient
        id="payment-wero_svg__a"
        x1={15.126}
        x2={12.156}
        y1={2.993}
        y2={6.629}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="#1D1C1C" stopOpacity={0} />
        <stop offset={0.68} stopColor="#1D1C1C" />
      </linearGradient>
      <linearGradient
        id="payment-wero_svg__b"
        x1={9.947}
        x2={12.99}
        y1={3.765}
        y2={0.757}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="#1D1C1C" stopOpacity={0} />
        <stop offset={0.68} stopColor="#1D1C1C" />
      </linearGradient>
    </defs>
    <rect width={64} height={24} fill="#FFF48D" rx={3} />
    <path
      fill="#fff"
      d="M1.451 3.015v17.987c0 .861.708 1.565 1.574 1.565h10.798c8.164 0 11.702-4.548 11.702-10.582S21.985 1.45 13.822 1.45H3.023c-.865 0-1.573.704-1.573 1.565z"
    />
    <path
      fill="#C06"
      d="M8.679 5.865v13.29h5.81c5.278 0 7.566-2.966 7.566-7.16 0-4.196-2.289-7.13-7.565-7.13H9.685c-.558 0-1.006.453-1.006 1.001z"
    />
    <path
      fill="#232323"
      fillRule="evenodd"
      d="M4.43 21.135h9.39c6.6 0 10.24-3.248 10.24-9.142 0-3.397-1.329-9.103-10.24-9.103H4.43c-.833 0-1.51.672-1.51 1.503v15.24c0 .83.677 1.503 1.51 1.503M3.424 4.393c0-.555.448-1.002 1.006-1.002h9.39c3.634 0 9.736 1.12 9.736 8.602 0 5.572-3.46 8.641-9.735 8.641H4.43a1 1 0 0 1-1.006-1.002V4.393"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.538 10.06a1.6 1.6 0 0 0-.562-.094v-.008h-1.33v3.21h1.346c.239 0 .446-.048.624-.127q.264-.129.439-.34c.116-.143.2-.317.26-.514a2.4 2.4 0 0 0 .085-.65q-.002-.4-.108-.695a1.6 1.6 0 0 0-.3-.491 1.3 1.3 0 0 0-.453-.293zm-.315 2.476a1 1 0 0 1-.293.048v.008h-.608v-2.025h.492c.169 0 .307.024.423.071a.7.7 0 0 1 .277.214.9.9 0 0 1 .154.332c.03.127.046.277.046.436 0 .182-.023.324-.068.45a1 1 0 0 1-.177.301.57.57 0 0 1-.246.166"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M15.176 9.967v.594h-1.647v.688h1.515v.546H13.53v.784h1.685v.593h-2.37v-3.21h2.332v.008z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m18.7 13.177-1.17-3.21h-.715l-1.178 3.21h.693l.246-.712h1.17l.239.712zm-1.525-2.42.393 1.178h-.807l.408-1.178h.007"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M19.816 9.966v2.617h1.523v.594h-2.207v-3.21z" />
    <path
      fill="#232323"
      d="M5.978 13.224c.834 0 1.509-.675 1.509-1.51a1.509 1.509 0 1 0-3.017 0c0 .835.675 1.51 1.508 1.51M6.875 19.263c-1.168 0-2.105-1.01-2.105-2.249V15.26c0-.62.468-1.129 1.057-1.129.588 0 1.056.501 1.056 1.129v4.003z"
    />
    <path
      fill="#1D1C1C"
      d="M53.49 12.078c0-1.764 1.255-3.371 3.423-3.371s3.432 1.608 3.432 3.371c0 1.764-1.255 3.372-3.432 3.372-2.168 0-3.423-1.608-3.423-3.372m4.95 0c0-.85-.56-1.635-1.527-1.635s-1.527.786-1.527 1.635c0 .85.57 1.637 1.527 1.637s1.527-.786 1.527-1.637M52.156 13.331c.722-.411 1.156-1.197 1.156-2.065 0-1.288-.93-2.385-2.376-2.385h-3.034v6.397h1.879v-1.636h.352l1.075 1.636h2.212zm-1.598-1.162h-.777V10.36h.786c.506 0 .83.412.83.905s-.334.904-.84.904M39.325 8.873l-1.128 3.812-1.1-3.812h-1.496l-1.11 3.812-1.118-3.812H31.39l2.272 6.385h1.631l1.055-3.476 1.046 3.476h1.64l2.272-6.385h-1.983zM44.152 13.699h-.004c-.703 0-1.196-.425-1.407-.987h4.775q.057-.316.058-.646c0-1.759-1.252-3.364-3.422-3.365v1.733c.707.001 1.194.426 1.404.986h-4.768a3.6 3.6 0 0 0-.058.646c0 1.76 1.253 3.367 3.417 3.367h.004v-1.734"
    />
    <path
      fill="url(#payment-wero_svg__a)"
      d="M12.756 6.732q.111 0 .218-.006a3.7 3.7 0 0 0 1.195-.255 3.13 3.13 0 0 0 1.589-1.414c.154-.282.267-.587.338-.905h-1.99q-.06.128-.142.242a1.4 1.4 0 0 1-.59.481 1.5 1.5 0 0 1-.616.124c-.447 0-.81-.173-1.07-.443l-1.293 1.308c.575.531 1.372.866 2.361.866z"
      transform="translate(31.39 8.7)"
    />
    <path
      fill="url(#payment-wero_svg__b)"
      d="M12.757 0C10.92 0 9.74 1.155 9.426 2.58h1.983c.237-.491.704-.847 1.348-.847.513 0 .911.221 1.17.556L15.234.97C14.65.38 13.812 0 12.758 0z"
      transform="translate(31.39 8.7)"
    />
    <path
      fill="#1D1C1C"
      d="M28.434 19.122a.265.265 0 0 1-.264-.264V5.144a.265.265 0 0 1 .527 0v13.714a.265.265 0 0 1-.263.264"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPaymentWero);
export default ForwardRef;
